<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">


        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-muted">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()"><i class="fa fa-user fa-1x push-5-r"></i>  {{occupant.completeName}}</h2>
            </div>

            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Unit Detail Information  -->

                    <div v-if="flagDisplayDetail===0" class="block">

                        <button  type="button" @click="toggleConfigView()" class="btn btn-default align-right" name="buttonAddPlanItem">
                          <i class="fa fa-gear fa-1x push-5-r "></i>{{ labelButtonConfig[actualLanguage] }}</button>

                        <h2 class="block-title push">Detail</h2>


                        <div class="col-xs-12 push">
                          <h2 class="block-title">Section qui affiche le détail du consommateur</h2>
                        </div>
                    </div>





                    <!-- Unit Detail Information  -->
                    <div v-else class="block">
                         <button  type="button" @click="toggleConfigView()" class="btn btn-default align-right" name="buttonAddPlanItem">
                          <i class="fa fa-close fa-1x push-5-r "></i>{{ labelButtonConfigClose[actualLanguage] }}</button>                       

                        <h1 class="block-title push">Configuration {{labelOccupant[actualLanguage]}} ID: {{ occupant.occupant_id}}</h1>

                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelFirstName[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6 push">
                                <input v-model="occupant.firstname" class="form-control align-center" type="test"  placeholder="">
                          </div>

                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelLastName[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6 push">
                                <input v-model="occupant.lastname" class="form-control align-center" type="test"  placeholder="">
                          </div>

                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelEmail[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6 push">
                                <input v-model="occupant.email" class="form-control align-center" type="test"  placeholder="">
                          </div>

                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelMobile[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6 push">
                                <input v-model="occupant.mobile_phone_number" class="form-control align-center" type="test"  placeholder="999 999-9999">
                          </div>


                          <button  type="button" @click="saveOccupantModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                          <spinner size="small" v-if="occupantIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 

                        </div>


                        <h1 class="block-title push">{{labelTitleSectionUnitAttribution[actualLanguage]}}</h1>
 
                        <div v-if="flagDisplayAttributionTable" class="col-xs-12 col-md-12">
                          <div  class="table-responsive push">
                              <table class="table table-striped table-vcenter">
                                  <thead>
                                      <tr>
                                          <th style="width: 25%;">{{attributionColumn01[actualLanguage]}}</th>
                                          <th style="width: 25%;">{{attributionColumn02[actualLanguage]}}</th>
                                          <th style="width: 25%;">{{attributionColumn03[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 25%;">{{attributionColumn04[actualLanguage]}}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for= "(attribution,index) in occupant.unit_attributions">
                                          <td class="font-w600">
                                            {{attribution.unit_reference_name}}
                                          </td>
                                          <td>
                                            <div class="col-md-12">
                                              <div class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="attribution.dateStart"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="yy-MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                            </div>                                            
                                          </td>
                                          <td>
                                              <div class="col-md-12">
                                              <div class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="attribution.dateEnd"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="yy-MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                            </div>                                            
                                          </td>

                                          <td class="text-center">
                                              <div class="btn-group">
                                                  <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                  @click="deleteOccupantAttribution(index)" title="Supprimer/Delete"><i class="fa fa-trash"></i></button>
                                              </div>
                                          </td>
                                      </tr>

                                  </tbody>
                              </table>

                          </div>
                        </div>

                        
                       <div v-if="flagAddAttribution" class="col-xs-12 col-md-12 push">

                          <div class="col-xs-12 col-sm-3">
                              <h6>{{labelUnit[actualLanguage]}}</h6>
                              <select class="form-control align-center" v-model=tempoUnit size="1">
                                  <option v-for="unit in unitList" :value="unit.unit_id">{{unit.reference_name}}</option>
                              </select>
                          </div>

                          <div class="col-xs-12 col-sm-3">
                            <h6>{{labelDateStart[actualLanguage]}}</h6>
                            <div class="input-daterange form-group row">
                                <div class="input-date-time-picker" >
                                  <date-picker
                                      class="el-input__inner form-control"
                                      v-model="tempoUnitDateStart"
                                      type="date"
                                      placeholder=""
                                      clear-icon=""
                                      format="yyyy-MM-dd"
                                      value-format="timestamp"
                                  />
                                </div>
                            </div>
                          </div>

                          <div class="col-xs-12 col-sm-3">
                            <h6>{{labelDateEnd[actualLanguage]}}</h6>
                            <div class="input-daterange form-group row">
                                <div class="input-date-time-picker" >
                                  <date-picker
                                      class="el-input__inner form-control"
                                      v-model="tempoUnitDateEnd"
                                      type="date"
                                      placeholder=""
                                      clear-icon=""
                                      format="yyyy-MM-dd"
                                      value-format="timestamp"
                                  />
                                </div>
                            </div>
                          </div>

                          <div class="col-xs-12 col-sm-3">
                            <h6 style="color:white;">-</h6>
                            <button  type="button" @click="saveOccupantAttribution()" class="btn btn-default align-right push" name="buttonAddPlanItem">
                            <spinner size="small" v-if="occupantIsSaving"></spinner>
                            <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveAttribution[actualLanguage] }}</span></button>

                            <button  type="button" @click="toggleAddAttribution()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                            <i class="fa fa-times fa-1x push-5-r "></i>{{ labelButtonCancel[actualLanguage] }}</button> 
                          </div>

                        </div>
                        <div v-else class="col-xs-12 col-md-12 push">
                            <button  type="button" @click="toggleAddAttribution()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                            <i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAjouterAttribution[actualLanguage] }}</button>                         
                        </div>




                        <h1 class="block-title push">{{labelTitleSectionFixCosts[actualLanguage]}}</h1>
                        <div class="col-xs-12 col-md-12">
                          <p class="push-30">{{labelFixCostExplanation[actualLanguage]}}</p>


                          <div v-if="occupant.fix_costs.length > 0" class="table-responsive push">
                              <table class="table table-striped table-vcenter">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%;">{{fixCostColumn01[actualLanguage]}}</th>
                                          <th style="width: 18%;">{{fixCostColumn02[actualLanguage]}}</th>
                                          <th style="width: 18%;">{{fixCostColumn03[actualLanguage]}}</th>
                                          <th style="width: 30%;">{{fixCostColumn04[actualLanguage]}}</th>
                                          <th style="width: 14%;">{{fixCostColumn05[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 10%;">{{fixCostColumn06[actualLanguage]}}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for= "(cost,index) in occupant.fix_costs">
                                          <td class="font-w600">
                                            <div class="col-xs-12 col-sm-3">
                                                <label class="css-input switch switch-success">
                                                <input type="checkbox" checked v-model="cost.yearlyFlag">
                                                <span></span></label>
                                            </div>
                                          </td>
                                          <td>
                                            <div class="col-md-12">
                                              <div v-if="cost.yearlyFlag==false" class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="cost.periodStart"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="yy-MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                              <div v-else class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="cost.periodStart"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                            </div>                                            
                                          </td>
                                          <td>
                                             <div class="col-md-12">
                                              <div v-if="cost.yearlyFlag==false" class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="cost.periodEnd"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="yy-MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                              <div v-else class="input-daterange form-group row">
                                                  <div class="input-date-time-picker" >
                                                    <date-picker
                                                        class="el-input__inner form-control"
                                                        v-model="cost.periodEnd"
                                                        type="date"
                                                        placeholder=""
                                                        clear-icon=""
                                                        format="MM-dd"
                                                        value-format="timestamp"
                                                    />
                                                  </div>
                                              </div>
                                            </div>                                            
                                          </td>
                                          <td>
                                            <div class="col-xs-12 col-sm-12 push">
                                                  <input v-model="cost.description" class="form-control align-center" type="test"  placeholder="">
                                            </div>
                                          </td>
                                          <td>
                                            <div class="col-xs-12 col-sm-12 push">
                                                  <input v-model="cost.cost" class="form-control align-center" type="test"  placeholder="">
                                            </div> 
                                          </td>
                                          <td class="text-center">
                                              <div class="btn-group">
                                                  <button class="btn btn-default" type="button" data-toggle="tooltip"
                                                  @click="deleteFixCost(index)" title="Supprimer/Delete"><i class="fa fa-trash"></i></button>
                                              </div>
                                          </td>
                                      </tr>

                                  </tbody>
                              </table>

                          </div>

                          <div class="col-xs-12 col-md-12 push">
                            <button  type="button" @click="addFixCostLine()" class="btn btn-xs align-right push" name="buttonAddPlanItem">
                            <i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddFixCost[actualLanguage] }}</span></button> 
                          </div>

                          <button  type="button" @click="saveOccupantModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                          <spinner size="small" v-if="occupantIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 
                        </div>


                        <h1 class="block-title push">Options</h1>
                        <div class="col-xs-12 col-md-12">

                            <div v-for="(category,index) in occupant.options" class="col-xs-12 col-md-12 push">
                              <h5 class="push">{{category.categoryTitle[actualLanguage]}}</h5>

                              <div v-for="(Option,index2) in category.options" class="col-xs-12 col-md-12 push">

                                <div v-if="Option.valueType=='bool'" class="col-xs-12 col-md-12">

                                  <div class="col-xs-12 col-sm-9">
                                      <h5>{{Option.optionLabel[actualLanguage]}}</h5>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                      <label class="css-input switch switch-success">
                                      <input type="checkbox" checked v-model="Option.value">
                                      <span></span><p v-if="Option.value">{{labelActivated[actualLanguage]}}</p>
                                      </label>
                                  </div>

                                </div>



                                <div v-if="Option.valueType=='stringNumber'" class="col-xs-12 col-md-12 push">
                                  <div class="col-xs-12 col-sm-9">
                                      <h6>{{Option.optionLabel[actualLanguage]}}</h6>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                        <input v-model="Option.value" class="form-control align-center" type="test"  placeholder="">
                                  </div>
                                </div>

                                <div v-if="Option.valueType=='listString'" class="col-xs-12 col-md-12">
                                  {{Option}}
                                </div>

                              </div>

                            </div>

                        </div>

                        <button  type="button" @click="saveOccupantModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                        <spinner size="small" v-if="occupantIsSaving"></spinner>
                        <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 

                    </div>

                    <!-- END Static Labels -->
                    </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';


export default {
  name: 'Occupant',
  props: ['occupant'],

  data() {
    return {
      flagDisplayBanner : 0,
      flagDisplayDetail : 0,
      profileIsSaving : false,
      occupantIsSaving : false,
      actualLanguage : "FR",
      labelTitleSection: {FR: 'Titre bannière', EN: 'Banner Title'},
      labelTitleBanner: {FR: 'Titre bannière', EN: 'Banner Title'},
      labelOccupant: {FR: 'Occupant', EN: 'Occupant'},

      labelButtonConfig: {FR: 'Configuration', EN: 'Configuration'},
      labelButtonConfigClose: {FR: 'Fermer configuration', EN: 'Close configuration'},
      labelButtonSaveModifications: {FR: 'Enregistrer modifications', EN: 'Save modifications'},

      labelFirstName: {FR: "Prénom de l'occupant principal", EN: 'Main occupant firstname'},
      labelLastName: {FR: "Nom du l'occupant principal", EN: 'Main occupant lastname'},
      labelEmail: {FR: "Courriel", EN: 'Email'},
      labelMobile: {FR: "Téléphone mobile", EN: 'Mobile phone number'},
      labelReportMonthDay: {FR: "Journée du mois de génération des rapport et relevés (à ce moment, les factures de services doivent avoir été saisies dans le système)",
                             EN: 'Day of the month for generating reports and statements (at this time, service invoices must have been entered into the system)'},


      labelTitleSectionUnitAttribution: {FR: "Attribution d'unité", EN: 'Unit assigment'},
      labelButtonAjouterAttribution: {FR: "Ajouter une attribution", EN: 'Add assigment'},
      labelButtonCancel: {FR: "Annuler", EN: 'Cancel'},
      flagAddAttribution : 0,
      flagDisplayAttributionTable : false,
      labelUnit: {FR: "Unité", EN: 'Unit'},
      labelDateStart: {FR: "Date début", EN: 'Date start'},
      labelDateEnd: {FR: "Date fin", EN: 'Date end'},
      labelButtonSaveAttribution: {FR: "Enregistrer l'attribution", EN: 'Save assigment'},
      unitListIsLoading : false,
      unitList : [],
      tempoUnit : '',
      tempoUnitDateStart : '',
      tempoUnitDateEnd : '',

      attributionColumn01: {FR: "Unité", EN: 'Unit'},
      attributionColumn02: {FR: "Date début", EN: 'Start date'},
      attributionColumn03: {FR: "Date fin", EN: 'End date'},
      attributionColumn04: {FR: "Action", EN: 'Action'},

      messageRemoveConfirmA:{FR: "Confirmer la supression de l'attribution de la ligne : ", EN: 'Confirm line assigment deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},



      labelFixCostExplanation: {FR: "Un coût fixe s'ajoute au relevé de consommation et s'applique pour la période mentionnée. Le coût total est divisé par le nombre de jour et ensuite calculé selon le nombre de jour du relevé. Un coût de type ANNUEL se voit répété a chaque années au mois et jour sélectionnés.",
                                 EN: "A fixed cost is added to the consumption statement and applies for the period mentioned. The total cost is divided by the number of days and then calculated according to the number of days of the statement. An ANNUAL type cost is repeated every year on the selected month and day."},
      labelTitleSectionFixCosts: {FR: "Coûts fixe", EN: 'Fixed costs'},

      labelButtonAddFixCost: {FR: 'Ajouter un coût fixe', EN: 'Add fixed cost'},
      fixCostColumn01: {FR: "Annuel", EN: 'Annual'},
      fixCostColumn02: {FR: "Date début", EN: 'Start date'},
      fixCostColumn03: {FR: "Date fin", EN: 'End date'},
      fixCostColumn04: {FR: "Description", EN: 'Description'},
      fixCostColumn05: {FR: "Coût total($)", EN: 'Total cost ($)'},
      fixCostColumn06: {FR: "Supprimer", EN: 'Delete'},

      errorMessageSelectUnit: {FR: "Vous devez sélectionner un unité.", EN: 'You must select one unit.'},
      errorMessageSelectDateStart: {FR: "Vous devez sélectionner une date de début.", EN: 'You must select a start date.'},
      errorMessageSelectDateEnd: {FR: "Vous devez sélectionner une date de fin.", EN: 'You must select a end date.'},
      labelActivated: {FR: "Activé", EN: 'Activated'},
      typeList : [],
      messageList : [],
      
    }
  },
  components: {
    Spinner,
    DatePicker,
    TimePicker,
    TimeSelect
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.flagDisplayBanner = ~this.flagDisplayBanner
    },

  toggleConfigView(){
    this.flagDisplayDetail = ~this.flagDisplayDetail
  },
  toggleAddAttribution(){
    this.flagAddAttribution = ~this.flagAddAttribution
  },


  saveOccupantModifications(){
        var requestData = {'postAction':'SaveOccupant',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'occupantData':this.occupant}
        this.occupantIsSaving=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.occupantIsSaving=false
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.occupantIsSaving=false
                  }
            })
    },


    addFixCostLine(){
      this.occupant.fix_costs.push({'yearlyFlag':false,
      'periodStart':'',
      'periodEnd':'',
      'description':'',
      'cost':''})
    },

    deleteFixCost(index){
      this.occupant.fix_costs.splice(index,1)
    },


    readUnitList(){
        var requestData = {'postAction':'GetBundleUnits',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer}
        this.unitListIsLoading=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.unitListIsLoading=false
                this.unitList = response.data.UnitList
                //console.log(this.MainServiceList)
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.unitListIsLoading=false
                  }
            })
    },

    saveOccupantAttribution(){
      var processToSaving = true

      if(this.tempoUnit.length==0){
        window.alert(this.errorMessageSelectUnit[this.actualLanguage])
        processToSaving = false
      }
      if(this.tempoUnitDateStart.length==0){
        window.alert(this.errorMessageSelectDateStart[this.actualLanguage])
        processToSaving = false
      }
      if(this.tempoUnitDateEnd.length==0){
        window.alert(this.errorMessageSelectDateEnd[this.actualLanguage])
        processToSaving = false
      }

      if(processToSaving){
        var requestData = {'postAction':'SaveOccupantAttribution',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'occupantId':this.occupant.occupant_id,
                          'unitId':this.tempoUnit,
                          'dateStart':this.tempoUnitDateStart,
                          'dateEnd':this.tempoUnitDateEnd}
        this.flagDisplayAttributionTable = false
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              console.log(response)
            if(response.data.Code=='OK'){
                this.occupant.unit_attributions = response.data.OccupantAttributions
                this.flagDisplayAttributionTable = true
                //console.log(this.MainServiceList)
                this.$nextTick(() => {
                  this.toggleAddAttribution()
                })
                
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })        
      }


    },

    deleteOccupantAttribution(index){
        var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+(index+1), this.messageRemoveConfirmB[this.actualLanguage]);

        if(confirmation=='DELETE'){
        var requestData = {'postAction':'DeleteOccupantAttribution',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'occupantId':this.occupant.occupant_id,
                          'index':index}
        this.flagDisplayAttributionTable = false
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.occupant.unit_attributions = response.data.OccupantAttributions
                this.flagDisplayAttributionTable = true
                //console.log(this.MainServiceList)
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
        }       
    },



    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    this.readUnitList()
    this.flagDisplayAttributionTable = true



    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// OccupantDisplay.vue?b1204af4